import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Integrations.css';

const INTEGRATIONS = [
  {
    id: 'parrot-seo-ai-engine',
    name: 'Parrot SEO AI Engine',
    description: 'WordPress plugin for automatic content optimization. Connect via API key to receive SEO suggestions.',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
      </svg>
    ),
    path: '/dashboard/integrations/parrot-seo-ai-engine',
  },
];

const Integrations = () => {
  const navigate = useNavigate();

  return (
    <div className="integrations-page">
      <div className="integrations-header">
        <h1>Integrations</h1>
        <p className="integrations-subtitle">
          Connect external tools and plugins to enhance your SEO workflow.
        </p>
      </div>

      <div className="integrations-bento">
        {INTEGRATIONS.map((integration) => (
          <button
            key={integration.id}
            type="button"
            className="integration-bento-block"
            onClick={() => navigate(integration.path)}
          >
            <div className="integration-bento-icon">{integration.icon}</div>
            <h3 className="integration-bento-name">{integration.name}</h3>
            <p className="integration-bento-desc">{integration.description}</p>
            <span className="integration-bento-cta">Configure →</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Integrations;
